import React, {Component} from 'react';
import MaterialIcon from '../../../../../MaterialIcon';

import FieldModifierValue from "./FieldModifierValue";


export default class FieldModifierSubQuery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            funcName: this.props.argument,
            showAddNew: false
        };

        this.onArgumentOptionUpdate = this.onArgumentOptionUpdate.bind(this);
        this.toggleModifier = this.toggleModifier.bind(this);
        this.onClickAddNewButton = this.onClickAddNewButton.bind(this);
        this.onClickNew = this.onClickNew.bind(this);
    }

    toggleModifier(modifierFunctionKey) {
        const funcName = modifierFunctionKey;
        this.setState(prevState => (
            {
                funcName: {
                    ...prevState.funcName,
                    funcName
                }
            }
        ), () => {
            this.props.onArgumentOptionUpdate(this.state.funcName);
        })
    }

    isGroup(argument) {
        return Object.keys(this.props.possibleFunctions).includes(argument.funcName);
    }

    onClickNew(isValue) {
        let newCondition;
        if (isValue) {
            newCondition = {
                type: "constantValue",
                funcType: "none",
                value: "",
                defaultValue: "",
                id: this.props.elementIdAutoIncrement + 1
            };
        } else {
            newCondition = {
                funcName: "+",
                funcArgs: [],
                id: this.props.elementIdAutoIncrement + 1
            };
        }

        this.setState(prevState => ({
            funcName: {
                ...prevState.funcName,
                funcArgs: [
                    ...prevState.funcName.funcArgs,
                    newCondition
                ]
            },
            showAddNew: false
        }), () => {
            this.props.onArgumentOptionUpdate(this.state.funcName);
            this.props.updateProperty('elementIdAutoIncrement', this.props.elementIdAutoIncrement + 1)
        });
    }

    onArgumentOptionUpdate(index, argumentData) {
        let fieldModifier = {...this.state.funcName};
        fieldModifier.funcArgs[index] = argumentData;

        this.setState({
            funcName: {
                ...fieldModifier
            }
        }, () => {
            this.props.onArgumentOptionUpdate(this.state.funcName)
        });
    }

    onArgumentDelete(index) {
        let funcName = {...this.state.funcName};
        funcName.funcArgs = funcName.funcArgs.filter((value, funcArgIndex) => funcArgIndex !== index);

        this.setState({
            funcName: {
                ...funcName
            }
        }, () => {
            this.props.onArgumentOptionUpdate(funcName);
        });
    }

    onClickAddNewButton() {
        this.setState(prevState => ({
            showAddNew: !prevState.showAddNew
        }));
    }

    render() {
        return (
            <div className="predicate-group-header-wrapper">
                <div className="predicate-group-header">
                    <div className="selected-func">
                        <div className="label and-label">{this.state.funcName.funcName}</div>
                    </div>
                    <div className="func-options">
                        {Object.keys(this.props.possibleFunctions).map((modifierFunctionKey, index) => {
                            if (this.state.funcName.funcName !== modifierFunctionKey) {
                                return <div className="label" key={index}
                                        onClick={() => this.toggleModifier(modifierFunctionKey)}>{(this.props.possibleFunctions[modifierFunctionKey])}
                                    </div>
                            }
                        })}
                    </div>
                    <span className="delete" onClick={() => this.props.onArgumentDelete()}>
                        <MaterialIcon icon="close"/>
                    </span>
                </div>
                <div className="predicate-group and">
                    {this.state.funcName.funcArgs.map((argument, index) => {
                        if (this.isGroup(argument)) {
                            return <FieldModifierSubQuery
                                key={index + "subquery2"}
                                disableArea={this.props.disableArea}
                                defaultPredicateValue={this.props.defaultPredicateValue}
                                userProperties={this.props.userProperties}
                                itemProperties={this.props.itemProperties}
                                contextProperties={this.props.contextProperties}
                                predicateBlockType={this.props.predicateBlockType}
                                argument={argument}
                                onArgumentOptionUpdate={(data) => this.onArgumentOptionUpdate(index, data)}
                                onArgumentDelete={() => this.onArgumentDelete(index)}
                                elementIdAutoIncrement={this.props.elementIdAutoIncrement}
                                updateProperty={this.props.updateProperty}
                                possibleFunctions={this.props.possibleFunctions}
                            />
                        } else {
                            return <FieldModifierValue
                                key={index + "value2"}
                                disableArea={this.props.disableArea}
                                {...argument}
                                userProperties={this.props.userProperties}
                                itemProperties={this.props.itemProperties}
                                contextProperties={this.props.contextProperties}
                                predicateBlockType={this.props.predicateBlockType}
                                onArgumentOptionUpdate={(data) => this.onArgumentOptionUpdate(index, data)}
                                onArgumentDelete={() => this.onArgumentDelete(index)}
                            />
                        }
                    })}
                </div>
                <div className="add-new-options">
                    <button onClick={this.onClickAddNewButton} className={"add-new-button and"}>
                        <span>+</span>
                    </button>
                    <div onClick={() => this.onClickNew(true)}
                         className={"new " + (this.state.showAddNew ? "active" : "")}>New Value
                    </div>
                    <div onClick={() => this.onClickNew(false)}
                         className={"new " + (this.state.showAddNew ? "active" : "")}>New Sub Query
                    </div>
                </div>
            </div>
        );
    }
}